import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// 短信通道
export function smsChannelList(data) { return axios.post(`${base.url}/cloud/sms/channel/list`, qs.stringify(data)) }
export function smsChannelDetail(id) { return axios.post(`${base.url}/cloud/sms/channel/detail`, qs.stringify({ id })) }
export function smsChannelAddOrUpdate(data) { return axios.post(`${base.url}/cloud/sms/channel/addOrUpdate`, qs.stringify(data)) }
export function smsChannelStatus(id, status) { return axios.post(`${base.url}/cloud/sms/channel/status`, qs.stringify({ id, status })) }
export function smsChannelDeleteBatchIds(ids) { return axios.post(`${base.url}/cloud/sms/channel/deleteBatchIds`, qs.stringify({ ids })) }

// 短信模版
export function smsTemplateList(data) { return axios.post(`${base.url}/cloud/sms/template/list`, qs.stringify(data)) }
export function smsTemplateDetail(id) { return axios.post(`${base.url}/cloud/sms/template/detail`, qs.stringify({ id })) }
export function smsTemplateAddOrUpdate(data) { return axios.post(`${base.url}/cloud/sms/template/addOrUpdate`, qs.stringify(data)) }
export function smsTemplateStatus(id, status) { return axios.post(`${base.url}/cloud/sms/template/status`, qs.stringify({ id, status })) }
export function smsTemplateDeleteBatchIds(ids) { return axios.post(`${base.url}/cloud/sms/template/deleteBatchIds`, qs.stringify({ ids })) }
export function smsTemplateBatchImport(data) { return axios.post(`${base.url}/cloud/sms/template/batchImport`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function smsTemplateTestSend(templateId, mobile, operator) { return axios.post(`${base.url}/cloud/sms/template/testSend`, qs.stringify({ templateId, mobile, operator })) }

// 短信发送记录
export function smsLogList(data) { return axios.post(`${base.url}/cloud/sms/log/list`, qs.stringify(data)) }
export function smsLogDetail(id) { return axios.post(`${base.url}/cloud/sms/log/detail`, qs.stringify({ id })) }
export function smsLogDeleteBatchIds(ids) { return axios.post(`${base.url}/cloud/sms/log/deleteBatchIds`, qs.stringify({ ids })) }
export function smsLogResend(id, operator) { return axios.post(`${base.url}/cloud/sms/log/resend`, qs.stringify({ id, operator })) }

// 验证码规则
export function smsRuleList(data) { return axios.post(`${base.url}/cloud/sms/rule/list`, qs.stringify(data)) }
export function smsRuleAddOrUpdate(data) { return axios.post(`${base.url}/cloud/sms/rule/addOrUpdate`, qs.stringify(data)) }

// 规则变更历史
export function smsRuleLogList(data) { return axios.post(`${base.url}/cloud/sms/ruleLog/list`, qs.stringify(data)) }
